import React from 'react'
import {
  GridToolbarContainer,
  GridToolbarQuickFilter,
} from '@mui/x-data-grid'

/**
 * DataGrid toolbar with just a quick-filter search box. Used by the admin
 * tables; the search value is read back via `onFilterModelChange` and applied
 * server-side (the tables are server-paginated).
 */
export const AdminQuickFilterToolbar = () => (
  <GridToolbarContainer sx={{ justifyContent: 'flex-end', p: 1 }}>
    <GridToolbarQuickFilter debounceMs={400} placeholder="Search…" />
  </GridToolbarContainer>
)

export default AdminQuickFilterToolbar
